__turbopack_context__.v({
  "className": "-HyE6G_className",
  "variable": "-HyE6G_variable",
});
